import React, { useState, useRef, useCallback } from "react"
import { TextField, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import "./Search.scss"
import { appActions } from "redux/app/slice/app"
import { useDispatch } from "react-redux"

const SearchComponent = ({ isExpandable = true, placeholder = "Search" }) => {
  const [searchValue, setSearchValue] = useState("")
  const [expanded, setExpanded] = useState(!isExpandable)
  const dispatch = useDispatch()
  const searchInputRef = useRef(null)

  const handleFocus = useCallback(() => {
    if (isExpandable) setExpanded(true)
  }, [isExpandable])

  const handleBlur = useCallback(() => {
    if (isExpandable && !searchValue) {
      setExpanded(false)
    }
  }, [isExpandable, searchValue])

  const handleSearchField = useCallback((e) => {
    const searchText = e.target.value
    setSearchValue(searchText)
    dispatch(appActions.setSearchField(searchText))
  }, [])

  return (
    <div className="box">
      <TextField
        type="search"
        autoComplete="off"
        value={searchValue}
        onChange={handleSearchField}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        inputRef={searchInputRef}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                style={{
                  color: isExpandable ? "inherit" : "white",
                  cursor: "pointer",
                  fontSize: !isExpandable ? "18px" : "30px"
                }}
              />
            </InputAdornment>
          ),
          className: `${isExpandable ? "input" : ""} ${expanded ? "expanded" : ""}`
        }}
        fullWidth
      />
    </div>
  )
}

export default SearchComponent
